import { render, staticRenderFns } from "./MedicalViewDetailsModal.vue?vue&type=template&id=7a3b73b9&scoped=true"
import script from "./MedicalViewDetailsModal.vue?vue&type=script&lang=js"
export * from "./MedicalViewDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./MedicalViewDetailsModal.vue?vue&type=style&index=0&id=7a3b73b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3b73b9",
  null
  
)

export default component.exports